export function getCampaignUrl(campaignIdentifier, options) {
    if (options === void 0) { options = {}; }
    var searchParams = new URLSearchParams();
    if (options.query) {
        Object.entries(options.query).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined && value !== null) {
                searchParams.set(key, String(value));
            }
        });
    }
    var queryParams = searchParams.toString() ? "?".concat(searchParams.toString()) : '';
    if (options.categoryTabId) {
        if (Array.isArray(options.categoryTabId)) {
            return "/campaigns/".concat(campaignIdentifier, "/categories/").concat(options.categoryTabId.join(',')).concat(queryParams);
        }
        return "/campaigns/".concat(campaignIdentifier, "/").concat(options.categoryTabId).concat(queryParams);
    }
    return "/campaigns/".concat(campaignIdentifier).concat(queryParams);
}
